<!--承诺书-->
<template>
  <div>
    <div id="formHtml" style="padding:30px 130px;color:#000000">
      <p class="MsoNormal" align="center" style="text-indent:30.1000pt;text-align:center;line-height:200%;"><b><span style="font-family: 仿宋; line-height: 100px; font-size: 20pt;">内部加油装置登记承诺书</span></b><b><span style="font-family: 仿宋; line-height: 200%; font-size: 15pt;"><o:p></o:p></span></b></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;">依据</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;">：</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;">上海市</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;"><font face="仿宋">沪经信委运【</font>2020】753号文精神：撬装加油装置的设立主体必须按照“谁设立、谁负责”原则，牢固树立安全意识，建立健全生产制度，严格落实内部撬装加油装置的建设、使用和管理要求。</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">我单位</span><u><div style="font-family: 仿宋; font-size: 14pt;min-width:220px;display:inline-block;border-bottom:solid 1px #000;text-indent:10px;">&nbsp;{{form.entName}}</div></u><span style="font-family: 仿宋; font-size: 14pt;">申请</span><span style="font-family: 仿宋; font-size: 14pt;">企业内部加油点备案，并郑重</span><span style="font-family: 仿宋; font-size: 14pt;">承诺：</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">一、提交的所有登记材料均真实有效，复印件与原件一致。</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">二、内部加油点安全运营承诺</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">1、严格按照国家法律、法规和国家标准或者行业标准、地方标准规定执行；</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">2、做好环保、消防、安全生产等工作，全面落实企业安全管理主体责任；</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">3、按有关标准和规定，使用合格加油装置和合格油品，规范作业区域设置；</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">4、按照规范要求，实时上传柴油采购电子签章合同信息，督促柴油供应商规范使用电子托运清单；</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
  mso-bidi-font-weight:bold;font-size:14.0000pt;mso-font-kerning:1.0000pt;">不对外销售和变相销售油品，不对外承包、委托管理；</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent: 24pt;"><span style="font-family: 仿宋; font-size: 14pt;">5、</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;">按照规定配备相应的信息化硬件设施，接入区属内部加油装置管理系统，主动接受职能部门监管。</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">三、如加油装置安全条件及运营管理不符合要求，在一个月的承诺期内完成整改，如不能完成整改则自愿停止运营并接受相关部门处理。</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">四、如遇政策调整</span><span style="font-family: 仿宋; font-size: 14pt;">、</span><span style="font-family: 仿宋; font-size: 14pt;">相关法律法规改变或</span><span style="font-family: 仿宋; font-size: 14pt;">自然不可抗力等因素</span><span style="font-family: 仿宋; font-size: 14pt;">，本单位</span><span style="font-family: 仿宋; font-size: 14pt;">无条件服</span><span style="font-family: 仿宋; font-size: 14pt;">从</span><span style="font-family: 仿宋; font-size: 14pt;">安排，</span><span style="font-family: 仿宋; font-size: 14pt;">所有关于加油装置投资建设、运营管理、拆除清运、应急支出及其他相关费用自行承担。</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">&nbsp;</span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;">特此承诺</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="font-family: 仿宋; font-size: 14pt;"><font face="仿宋">法定代表人签字：</font> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业盖章：</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:156.0000pt;mso-char-indent-count:13.0000;"><span style="font-family: 仿宋; font-size: 14pt;">&nbsp;</span></p><p class="MsoNormal" style="text-indent: 24pt;"><span style="font-family: 仿宋; font-size: 14pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font face="仿宋">　　　　　　　年</font> &nbsp;&nbsp;&nbsp;月 &nbsp;&nbsp;&nbsp;日</span><span style="font-family: 仿宋; font-size: 14pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-indent:24.0000pt;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-family:'Times New Roman';
  font-size:14.0000pt;mso-font-kerning:1.0000pt;">&nbsp;</span></p>

    </div>
    <div class="dialog-footer" style="margin-top:10px;text-align: center;">
      <el-button @click="closeDialog()" size="small">取 消</el-button>
      <el-button  size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
    </div>
    <a id="download" v-show="false"/>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {enterpriseDetail} from "../../../api/admin/sysEnterprise/index";
    import {addObj, getObj, putObj} from "../../../api/admin/sysFormCommitment/index";
    import * as html2canvas from "html2canvas";

    export default {
        name: 'commitment',
        props: ["formId", "prop"],
        data() {
            return {
                form: {
                    entName:null,
                }
            }
        },
        created() {
            this.init();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        watch: {
        },
        methods: {
            init: function () {
                if(this.formId){
                    getObj(this.formId).then(response=>{
                        this.form=response;
                    })
                }else {
                    enterpriseDetail({}).then(response => {
                        this.form.entName = response.entName;
                    });
                }
            },
            html(callback) {
                html2canvas(document.querySelector("#formHtml"), {scale: 2}).then(canvas => {
                    callback && callback(canvas);
                })
            },
            download(fileName){
                this.html((canvas)=>{
                    fileName += ".png";
                    if (window.navigator.msSaveBlob) {
                        var blob = canvas.msToBlob()
                        window.navigator.msSaveBlob(blob, fileName)
                    } else {
                        var url = canvas.toDataURL()     //把canvas转成base64
                        // 写一个隐藏的按标签，借助按标签的download属性下载图片
                        document.querySelector('#download').href = url;
                        document.querySelector('#download').download = fileName;
                        document.querySelector('#download').click()
                    }
                });
            },
            create() {
                this.editStatus = false;
                this.$nextTick(()=>{
                    addObj(this.form).then((response) => {
                        this.html(canvas=>{
                            this.$emit("on-success", {...response, content: canvas.toDataURL()});
                        })
                    })
                })
            },
            checkRadio: function (prop, index, array) {
                if (!array[index].state) {
                    this.form[prop] = index;
                    array.forEach(item => {
                        item.state = false;
                    })
                } else {
                    prop = null;
                }
            },
            fdate: function (a, b, c) {
                return (a || "") + "-" + (b || "") + "-" + (c || "");
            },
            edit: function (val) {
                if (val && String.valueOf(val).length > 0) {
                    return "edit";
                }
                return "";
            },
            closeDialog() {
                this.$emit('close')
            }
        }
    }
</script>
<style scoped>
  table td {
    background: #FFF;
    padding: 0px 4px;
    height: 40px;
    box-sizing: border-box;
    text-align: center;
  }

  table td .checkbox {
    width: 16px;
    height: 16px;
    border: solid 1px #000;
    background: #FFF;
    position: relative;
    top: 3px;
  }

  table td input {
    background: url(./img/edit.png) 10px no-repeat;
    width: 100%;
    height: 100%;
    border: none;
    text-indent: 0px;
    border: none;
    font-size: 14px;
    outline: none;
    padding-left: 10px;
    box-sizing: border-box;
  }

  table td .shortInput {
    width: 60px;
    height: 100%;
    border: none;
  }

  table td .longInput {
    width: 290px;
    height: 100%;
    border: none;
  }

  .edit {
    background: transparent;
  }
</style>